<template>
    <div id="tooltip-card">
      <v-card
        class="pa-2 mb-6 primary darken-2 overlay-reservoir-center"
        max-width="420"
      >
        <v-card-title>
          <v-row :align="showTooltip.label_subtitle ? 'start' : 'center'">
            <v-icon v-if="showTooltip.icon_params" class="pa-1 mr-2" size="18" color="white"
              :style="`border-radius: 50%;background-color: ${showTooltip.icon_params.background_color}`">{{
                showTooltip.icon_params.class }}</v-icon>
            <div>
              <h1 v-if="showTooltip.value_title" class="pa-0 ma-0 white--text tooltip-title">
                <span v-if="showTooltip.label_title">{{ showTooltip.label_title }}&nbsp;&nbsp;-&nbsp;&nbsp;</span>{{
                  showTooltip.value_title }}
              </h1>
              <h1 v-else class="pa-0 ma-0 white--text tooltip-title">
                {{ showTooltip.name }}
              </h1>
              <h2 v-if="showTooltip.value_subtitle" class="mt-0 pa-0 ma-0 tooltip-subtitle">
                <span v-if="showTooltip.label_subtitle">{{ showTooltip.label_subtitle }}:&nbsp;&nbsp;</span>
                <span>{{ showTooltip.value_subtitle }}</span>
              </h2>
            </div>
          </v-row>
        </v-card-title>
        <v-card-text v-if="showTooltip.items.length" class="pa-0 ma-0">
          <div class="mt-1" v-for="(property, index2) in showTooltip.items" :key="index2">
            <template v-if="property.label == 'separator'">
                <hr style="width: 100%; height: 1px;">
            </template>

            <template v-else>
                <v-icon class="mr-2" size="16" color="secondary lighten-1">{{
                  property.icon_label ? property.icon_label : 'waves'
                }}</v-icon>
                <span class="white--text mr-1" style="font-weight: normal; font-size: 14px; line-height: 18px">{{ property.label
                }}:&ensp;</span>
                
                <strong v-if="property.value" class="white--text"
                  style="font-weight: bold; font-size: 16px; line-height: 20px">{{formatIfDate( property) }} {{
                    property.suffix }}</strong>
                <strong v-else class="white--text" style="font-weight: bold; font-size: 16px; line-height: 20px">-</strong>
            </template>
          </div>
        </v-card-text>
        <v-card-text v-if="showTooltip.updatedAt">
          <v-row class="align-center justify-start">
            <v-icon class="ml-1 mr-3" color="white" size="16" left>restore</v-icon>
            <span class="white--text" style="
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 16px;
              ">
              Atualizado em {{ formatDate(showTooltip.updatedAt) }}
            </span>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </template>
  
  <script>
  import moment from 'moment';
  export default {
    name: 'TooltipPocos',
    props: ['tooltipParams', 'overlayLayerTooltipCard',],
    components: {
    },
    data: () => ({}),
    computed: {
      showTooltip() {
        let firstTooltip = undefined;
        if (this.tooltipParams.length) {
          firstTooltip = this.tooltipParams[0];
          for (const tooltipKey in this.tooltipParams) {
            if (this.tooltipParams[tooltipKey].zindex > firstTooltip.zindex) {
              firstTooltip = this.tooltipParams[tooltipKey];
            }
          }
        }
        return firstTooltip;
      },
    },
    methods: {
      formatDate(date) {
        return moment(date).format('DD/MM/YYYY HH:mm');
      },
      formatIfDate(property) {
        if(property.label == "Data perfuração"){
          if(property.value.length > 0){
            return property.value.substring(0, 10);
          }
        } else if (property.label ==  "Vencimento") {
          if(property.value){
            const replacedVal = property.value.replaceAll('/', '-');
            return moment(replacedVal).format("DD-MM-YYYY");
          }
        }
        return property.value;
      },
    //   formatValue(value) {
    //     const parsedValue = parseFloat(value);
    //     if(isNaN(parsedValue)){
    //         return value;
    //     }else{
    //         return new Intl.NumberFormat("pt-BR").format(parsedValue); 
    //     }
    //   },
    },
  };
  </script>
  
  <style scoped>
  .tooltip {
    width: 300px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px;
    opacity: 0.8;
    position: absolute;
    transition: 0.5s all ease;
    transition-delay: 0.5s;
    z-index: 1000;
  }
  
  hr.solid {
    border-top: 3px solid #fff;
  }
  
  .tooltip-title {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
  }
  
  .tooltip-subtitle {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
  }
  </style>
  